import React, { JSX } from 'react';

import { ListViewTable } from '~/src/dash/components/tables/ListViewTable';
import {
  IListViewTableColumnInfo,
  IListViewTableRow,
  Order,
  RowsPerPage,
} from '~/src/dash/components/tables/ListViewTable/common';
import { publicaColors } from '~/src/dash/utils/colors';
import { LoadingState } from '~/src/dash/utils/loading-states';
import { IAdBreakConfig } from '~/src/dash/views/inventory-rules/AllRules/AdBreakDrawer/config';
import { IAdBreak } from '~/src/dash/views/inventory-rules/common';

interface IProps {
  cfg: IAdBreakConfig;
  data: IAdBreak[];
  loadState: LoadingState;
  handleOnClickColumnHeader: (column: IListViewTableColumnInfo) => void;
  visibleDrawerRows: IListViewTableRow[];
  order: Order;
  orderBy: string;
  page: number;
  rowsPerPage: RowsPerPage;
  handleChangePage: (event: React.MouseEvent | null, page: number) => void;
  handleChangeRowsPerPage: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const AdBreakTable = ({
  cfg,
  data,
  loadState,
  handleOnClickColumnHeader,
  visibleDrawerRows,
  order,
  orderBy,
  page,
  rowsPerPage,
  handleChangePage,
  handleChangeRowsPerPage,
}: IProps): JSX.Element => {
  const { cypressClassName } = cfg;

  return (
    <>
      <ListViewTable
        className={`id-name-table-${cypressClassName}`}
        loadState={loadState}
        activeColumnKeys={cfg.defaultState.activeColumnKeys}
        columns={cfg.table.columns}
        order={order}
        orderBy={orderBy}
        page={page}
        rows={visibleDrawerRows}
        rowsPerPage={rowsPerPage}
        totalRowCount={data.length}
        handleOnClickColumnHeader={handleOnClickColumnHeader}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        isExpanded={false}
        isReadAuthorized={true}
        isWriteAuthorized={false}
        key={cypressClassName}
        backgroundColor={publicaColors.veryLightGray}
      />
    </>
  );
};
